import { Step as ModelStep } from "@redotech/redo-model/return-flow";
import { submitClaimFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  isSubmitClaimStepValid,
  SubmitClaimState,
} from "@redotech/redo-model/return-flow-step-valid";
import {
  ReturnOptionMethod,
  StoreCreditType,
} from "@redotech/redo-model/return-flow/return-option";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import RefreshIcon from "@redotech/redo-web/icon-old/refresh.svg";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";
import { getModelReturnOptionMethod } from "./return";

export function returnOptionLabels(
  value: ReturnOptionMethod["type"] | undefined,
): string | undefined {
  switch (value) {
    case ReturnOptionMethod.STORE_CREDIT:
      return "Store credit";
    case ReturnOptionMethod.EXCHANGE:
      return "Same Item Exchange";
    case ReturnOptionMethod.REFUND:
      return "Refund";
  }
  return undefined;
}

export const SUBMIT_CLAIM = (
  Details: React.ComponentType<StepTypeDetailsProps<SubmitClaimState>>,
): StepType<SubmitClaimState, ModelStep.SubmitClaim> => ({
  Details: (props: StepTypeDetailsProps<SubmitClaimState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  title: "Submit Claim",
  valid(state) {
    return isSubmitClaimStepValid(state).valid;
  },
  Icon: RefreshIcon,
  description(state) {
    return returnOptionLabels(state.option.method) || "";
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: {
    option: {
      method: ReturnOptionMethod.EXCHANGE,
      creditType: StoreCreditType.GIFT_CARD,
      requireSendBack: false,
      chargeCustomerForNewOrderShipping: false,
      variantExchangeAddOn: false,
    },
  },
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  toModel(state) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.SUBMIT_CLAIM,
      option: {
        method: getModelReturnOptionMethod(
          state.option.method,
          state.option.creditType,
        ),
        requireSendBack: state.option.requireSendBack,
        chargeCustomerForNewOrderShipping:
          state.option.chargeCustomerForNewOrderShipping || false,
        variantExchangeAddOn: state.option.variantExchangeAddOn || false,
        variantExchangeAddOnVariantId:
          state.option.variantExchangeAddOnVariantId,
        variantExchangeAddOnTitle: state.option.variantExchangeAddOnTitle,
        variantExchangeAddOnAcceptButton:
          state.option.variantExchangeAddOnAcceptButton,
        variantExchangeAddOnRejectButton:
          state.option.variantExchangeAddOnRejectButton,
      },
    };
  },
  fromModel(model) {
    return submitClaimFromModel(model);
  },
});

export {
  type SubmitClaimOption,
  type SubmitClaimState,
} from "@redotech/redo-model/return-flow-step-valid";
